if (!customElements.get('samzwam-pickup')) {
  class SamzwamPickup extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-reset')) {
        this.post({ Bezorging: 'Thuisbezorgen', Pakketpunt: '' });
        return;
      }
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.details = this.querySelector('.samzwam-pickup__details');
      this.field = this.querySelector('textarea');
      if (!this.checkbox || !this.details || !this.field) return;

      this.checkbox.addEventListener('change', () => {
        this.details.hidden = !this.checkbox.checked;
        this.save();
      });
      this.field.addEventListener('change', () => this.save());
    }

    save() {
      const attributes = this.checkbox.checked
        ? { Bezorging: 'Pakketpunt', Pakketpunt: this.field.value.trim() }
        : { Bezorging: 'Thuisbezorgen', Pakketpunt: '' };
      this.post(attributes);
    }

    post(attributes) {
      fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
      }).catch(() => {});
    }
  }
  customElements.define('samzwam-pickup', SamzwamPickup);
}

// Op /cart staat het blok buiten het deel dat Dawn ververst bij een andere hoeveelheid.
// Na elke wijziging de footer-sectie ophalen en alleen het pakketpuntblok vervangen,
// zodat het verschijnt of verdwijnt (alleen brievenbusproducten, hooguit 6 stuks).
if (!window.samzwamPickupRefresh && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  window.samzwamPickupRefresh = true;
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    const wrap = document.querySelector('.samzwam-pickup-wrap[data-context="cart"]');
    const footer = document.getElementById('main-cart-footer');
    if (!wrap || !footer || !footer.dataset.id) return;
    fetch(`${window.location.pathname}?section_id=${footer.dataset.id}`)
      .then((response) => response.text())
      .then((html) => {
        const nieuw = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.samzwam-pickup-wrap[data-context="cart"]');
        if (nieuw) wrap.innerHTML = nieuw.innerHTML;
      })
      .catch(() => {});
  });
}
